// import React, {
//   useState,
//   useEffect,
//   useRef,
//   useCallback,
//   useMemo,
// } from 'react';
// import {
//   MdOutlineCheckBox,
//   MdOutlineIndeterminateCheckBox,
// } from 'react-icons/md';
// import { useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { Scope } from '@unform/core';
// import * as Yup from 'yup';
// import { toast } from 'react-toastify';
// import { format, parseISO } from 'date-fns';

// import api from '../../../../services/api';
// import history from '../../../../services/history';

// import { AppError } from '../../../../errors/AppError';
// import {
//   opTipoAcesso,
//   opTipoDocumento,
//   opMascaraDocumento,
// } from '../../../../lib/const';
// import {
//   opAdministrador,
//   opEmpresaAdministrador,
//   opDocumento,
//   opCatalogoSituacao,
// } from '../../../../lib/inputOption';
// import { YupValidaDocumento, splitArray } from '../../../../lib/inputUtils';

// import {
//   permiteEmpEmailUsuarioReponsavel,
//   vinculaCatalogoUsuario,
// } from '../../../../lib/paramUtils';

// import TitleBar from '../../../../components/TitleBar';
// import { FormWrapper, Form } from '../../../../components/Form';
// import Input from '../../../../components/Form/Input';
// import Select from '../../../../components/Form/Input/Select';
// import Checkbox from '../../../../components/Form/Input/Checkbox';
// import MaskedInput from '../../../../components/Form/Input/MaskedInput';
// import { RowMaster, Table } from '../../../../components/Table';
// import TableHeader from '../../../../components/Table/TableHeader';
// import Pagination from '../../../../components/EditorAI/Pagination';
// import {
//   CatalogoActionArea,
//   CatalogoCard,
//   CatalogoCount,
//   CatalogoDescription,
//   CatalogoHeaderInfo,
//   CatalogoTitle,
//   CatalogoTitleRow,
//   CatalogoToolbar,
//   FilterContainer,
//   FilterInput,
//   FilterLabel,
//   LeftWrapper,
//   MasterWrapper,
//   PrimaryButton,
//   RightWrapper,
//   ToolbarButton,
// } from './styles';

// const schema = Yup.object().shape({
//   nome: Yup.string()
//     .min(3, 'O campo "nome" precisa ter no mínimo 3 caracteres')
//     .required('O campo "Nome" é obrigatório'),
//   email: Yup.string()
//     .email('E-mail inválido')
//     .required('O campo "E-mail" é obrigatório'),
//   emailResponsavel: Yup.string()
//     .when('$paramField1', (paramField1, schema1) =>
//       paramField1
//         ? schema1.required('O campo "E-mail Responsável" é obrigatório')
//         : schema1
//     )
//     .email('E-mail responsável é inválido'),
//   adm: Yup.number()
//     .typeError('O campo "Administrador" deve ser preenchido')
//     .required('O campo "Administrador" é obrigatório'),
//   utilizaMobile: Yup.string().oneOf(['0', '1']),
//   tipoDocumento: Yup.number()
//     .typeError('O campo "Documento" deve ser preenchido')
//     .required('O campo "Documento" precisa ser preenchido'),
//   documento: Yup.string()
//     .required('O campo "Número Documento" é obrigatório')
//     .test('documento', 'O documento é inválido', function isValid(value) {
//       return YupValidaDocumento(value, this);
//     }),
// });

// function EmpresaUsuarioEditar() {
//   const formRef = useRef(null);
//   const paginationRef = useRef(null);

//   const catalogosInicializadosRef = useRef(new Set());

//   const location = useLocation();
//   const { idEmpresa, idUsuario } = location.state;

//   const { adm: tipoAcesso } = useSelector((state) => state.user.profile || {});

//   const [usuario, setUsuario] = useState({});
//   const [usuarioComplemento, setUsuarioComplemento] = useState([]);
//   const [tipoDocumento, setTipoDocumento] = useState(opTipoDocumento.CPF);
//   const [nivelUsuario, setNivelUsuario] = useState(opAdministrador[0]);

//   const [empresaCatalogo, setEmpresaCatalogo] = useState([]);
//   const [catalogosSelecionados, setCatalogosSelecionados] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPage, setTotalPage] = useState(0);
//   const [filtroCatalogo, setFiltroCatalogo] = useState('');

//   const showCatalogoPanel = vinculaCatalogoUsuario();

//   const normalizaCatalogosSelecionados = useCallback((payload) => {
//     const lista =
//       payload?.catalogos ||
//       payload?.catalogo ||
//       payload?.usuarioCatalogo ||
//       payload?.catalogosVinculados ||
//       [];

//     if (!Array.isArray(lista)) return [];

//     return lista
//       .map((item) =>
//         typeof item === 'object' ? Number(item.idCatalogo) : Number(item)
//       )
//       .filter(Boolean);
//   }, []);

//   const carregaEmpresaCatalogo = useCallback(async () => {
//     if (!showCatalogoPanel) return;

//     try {
//       const response = await api.get(`/empresa/${idEmpresa}/catalogo`, {
//         params: {
//           page: currentPage,
//           idUsuario,
//         },
//       });

//       const catalogos = response.data.catalogo
//         .map(({ arquivo, empresas, ...catalogo }) => {
//           const { modelos, fabricante } = arquivo;

//           return {
//             ...catalogo,
//             fabricante: fabricante.descricao,
//             modelo: modelos.map((m) => m.descricao).join(', '),
//             relacionadoEmpresa:
//               empresas.filter((e) => e.idEmpresa === idEmpresa).length > 0,
//           };
//         })
//         .filter((catalogo) => catalogo.relacionadoEmpresa);

//       setEmpresaCatalogo(catalogos);
//       setTotalPage(response.data.total || 0);

//       const idsVinculadosPagina = catalogos
//         .filter((catalogo) => catalogo.vinculadoUsuario)
//         .map((catalogo) => Number(catalogo.idCatalogo))
//         .filter(Boolean);

//       if (idsVinculadosPagina.length > 0) {
//         setCatalogosSelecionados((oldState) => {
//           const novosIds = idsVinculadosPagina.filter(
//             (idCat) => !catalogosInicializadosRef.current.has(idCat)
//           );

//           if (novosIds.length === 0) {
//             return oldState;
//           }

//           novosIds.forEach((idCat) =>
//             catalogosInicializadosRef.current.add(idCat)
//           );

//           return [...new Set([...oldState, ...novosIds])];
//         });
//       }

//       if (
//         response.data.total > 0 &&
//         currentPage > response.data.total &&
//         paginationRef.current
//       ) {
//         paginationRef.current.setPage(1);
//         setCurrentPage(1);
//       }
//     } catch (err) {
//       AppError(err);
//     }
//   }, [idEmpresa, idUsuario, currentPage, showCatalogoPanel]);

//   useEffect(() => {
//     let mounted = true;

//     async function carregaUsuario() {
//       try {
//         const response = await api.get(
//           `empresa/${idEmpresa}/usuario/${idUsuario}`
//         );

//         if (!mounted) return;

//         const {
//           adm,
//           utilizaMobile,
//           tipoDocumento: tipoDoc,
//           documento = '',
//           dataDesa,
//           complemento,
//         } = response.data;

//         const opAdm =
//           Number(tipoAcesso) === opTipoAcesso.ADMIN_EMPRESA
//             ? opEmpresaAdministrador.find(
//                 (item) => Number(item.value) === Number(adm)
//               ) || opEmpresaAdministrador[0]
//             : opAdministrador.find(
//                 (item) => Number(item.value) === Number(adm)
//               ) || opAdministrador[0];

//         formRef.current.setFieldValue('adm', opAdm);
//         formRef.current.setFieldValue('utilizaMobile', utilizaMobile);
//         formRef.current.setFieldValue(
//           'tipoDocumento',
//           opDocumento[tipoDoc] || opDocumento[0]
//         );

//         if (documento) {
//           formRef.current.setFieldValue('documento', documento);
//         }

//         setTipoDocumento(tipoDoc || opTipoDocumento.CPF);
//         setNivelUsuario(opAdm);

//         setUsuario({
//           ...response.data,
//           dataDesa: dataDesa
//             ? format(parseISO(dataDesa), 'dd/MM/yyyy HH:mm:ss')
//             : null,
//         });

//         setUsuarioComplemento(complemento);

//         if (showCatalogoPanel) {
//           const selecionadosDaResposta = normalizaCatalogosSelecionados(
//             response.data
//           );

//           if (selecionadosDaResposta.length > 0) {
//             setCatalogosSelecionados(selecionadosDaResposta);

//             selecionadosDaResposta.forEach((idCat) =>
//               catalogosInicializadosRef.current.add(Number(idCat))
//             );
//           } else {
//             const responseCatalogoUsuario = await api.get(
//               `/empresa/${idEmpresa}/usuario/${idUsuario}/catalogo`
//             );

//             if (!mounted) return;

//             const idsNormalizados = normalizaCatalogosSelecionados(
//               responseCatalogoUsuario.data
//             );

//             setCatalogosSelecionados(idsNormalizados);

//             idsNormalizados.forEach((idCat) =>
//               catalogosInicializadosRef.current.add(Number(idCat))
//             );
//           }
//         }
//       } catch (err) {
//         AppError(err, formRef);
//       }
//     }

//     carregaUsuario();

//     return () => {
//       mounted = false;
//     };
//   }, [
//     idEmpresa,
//     idUsuario,
//     tipoAcesso,
//     normalizaCatalogosSelecionados,
//     showCatalogoPanel,
//   ]);

//   useEffect(() => {
//     carregaEmpresaCatalogo();
//   }, [carregaEmpresaCatalogo]);

//   const handleConfirmar = useCallback(
//     async (data) => {
//       try {
//         await schema.validate(data, {
//           context: {
//             paramField1: permiteEmpEmailUsuarioReponsavel(),
//           },
//           abortEarly: false,
//         });

//         const {
//           nome,
//           email,
//           emailResponsavel,
//           adm,
//           utilizaMobile,
//           tipoDocumento: tipoDoc,
//           documento,
//           complemento,
//         } = data;

//         const fmtComplemento = complemento
//           ? Object.entries(complemento).map(([chave, valor]) => ({
//               chave,
//               valor,
//             }))
//           : null;

//         await api.put(`empresa/${idEmpresa}/usuario/${idUsuario}`, {
//           nome,
//           email,
//           emailResponsavel,
//           adm: String(adm),
//           utilizaMobile: String(utilizaMobile),
//           tipoDocumento: String(tipoDoc),
//           documento,
//           complemento: fmtComplemento,
//         });

//         toast.success('Usuário atualizado com sucesso!');
//       } catch (err) {
//         AppError(err, formRef);
//       }
//     },
//     [idEmpresa, idUsuario]
//   );

//   const handleSalvarCatalogos = useCallback(async () => {
//     try {
//       const payload = {
//         catalogos: Array.isArray(catalogosSelecionados)
//           ? catalogosSelecionados
//           : [],
//       };

//       await api.post(
//         `/empresa/${idEmpresa}/usuario/${idUsuario}/vinculo/catalogo`,
//         payload
//       );

//       toast.success('Catálogos vinculados atualizados com sucesso!');
//     } catch (err) {
//       AppError(err);
//     }
//   }, [idEmpresa, idUsuario, catalogosSelecionados]);

//   const handleTipoDocumento = useCallback((value) => {
//     setTipoDocumento(value);
//   }, []);

//   const handleNivelUsuario = useCallback((usuarioSelecionado) => {
//     setNivelUsuario(usuarioSelecionado);
//   }, []);

//   const handleToggleCatalogo = useCallback((idCatalogo) => {
//     setCatalogosSelecionados((oldState) => {
//       if (oldState.includes(idCatalogo)) {
//         return oldState.filter((id) => id !== idCatalogo);
//       }

//       return [...oldState, idCatalogo];
//     });
//   }, []);

//   const empresaCatalogoFiltrado = useMemo(() => {
//     const termo = filtroCatalogo.trim().toLowerCase();

//     if (!termo) return empresaCatalogo;

//     return empresaCatalogo.filter((catalogo) => {
//       const nome = String(catalogo.nome || '').toLowerCase();
//       const modelo = String(catalogo.modelo || '').toLowerCase();

//       return nome.includes(termo) || modelo.includes(termo);
//     });
//   }, [empresaCatalogo, filtroCatalogo]);

//   const handleSelecionarTodosCatalogos = useCallback(() => {
//     const idsDaPagina = empresaCatalogo
//       .map((catalogo) => Number(catalogo.idCatalogo))
//       .filter(Boolean);

//     setCatalogosSelecionados((oldState) => [
//       ...new Set([...oldState, ...idsDaPagina]),
//     ]);
//   }, [empresaCatalogo]);

//   const handleDesmarcarTodosCatalogos = useCallback(() => {
//     const idsDaPagina = empresaCatalogo
//       .map((catalogo) => Number(catalogo.idCatalogo))
//       .filter(Boolean);

//     setCatalogosSelecionados((oldState) =>
//       oldState.filter((id) => !idsDaPagina.includes(Number(id)))
//     );
//   }, [empresaCatalogo]);

//   return (
//     <>
//       <TitleBar back={!!location.background} title="Alterar Usuário" />

//       <MasterWrapper $showCatalogoPanel>
//         {/* LADO ESQUERDO - DADOS DO USUÁRIO */}
//         <LeftWrapper>
//           <FormWrapper>
//             <Form
//               id="formUsuario"
//               ref={formRef}
//               initialData={usuario}
//               onSubmit={handleConfirmar}
//               autoComplete="off"
//             >
//               <Form.Column>
//                 <Form.Row>
//                   <Input
//                     id="login"
//                     name="login"
//                     label="Login"
//                     type="text"
//                     disabled
//                   />
//                   <Input
//                     id="dataDesa"
//                     name="dataDesa"
//                     label="Data desativação"
//                     type="text"
//                     width={500}
//                     disabled
//                   />
//                 </Form.Row>

//                 <Form.Row>
//                   <Input id="nome" name="nome" label="Nome" type="text" />
//                   <Input id="email" name="email" label="E-mail" type="text" />
//                 </Form.Row>

//                 <Form.Row>
//                   {tipoAcesso === opTipoAcesso.ADMIN_PLATAFORMA && (
//                     <Select
//                       id="adm"
//                       name="adm"
//                       label="Administrador"
//                       isSearchable={false}
//                       defaultValue={opAdministrador[0]}
//                       options={opAdministrador}
//                       onChange={(usuarioSelecionado) =>
//                         handleNivelUsuario(usuarioSelecionado)
//                       }
//                     />
//                   )}

//                   {tipoAcesso === opTipoAcesso.ADMIN_EMPRESA && (
//                     <Select
//                       id="adm"
//                       name="adm"
//                       label="Administrador"
//                       isSearchable={false}
//                       defaultValue={opEmpresaAdministrador[0]}
//                       options={opEmpresaAdministrador}
//                       onChange={(usuarioSelecionado) =>
//                         handleNivelUsuario(usuarioSelecionado)
//                       }
//                     />
//                   )}

//                   <Select
//                     id="tipoDocumento"
//                     name="tipoDocumento"
//                     label="Documento"
//                     defaultValue={opDocumento[opTipoDocumento.CPF]}
//                     options={opDocumento}
//                     isSearchable={false}
//                     onChange={({ value }) => {
//                       handleTipoDocumento(value);
//                     }}
//                     width={400}
//                   />

//                   <MaskedInput
//                     id="documento"
//                     name="documento"
//                     label="Número Documento"
//                     mask={opMascaraDocumento[tipoDocumento] || ''}
//                   />
//                 </Form.Row>

//                 <Form.Row>
//                   {permiteEmpEmailUsuarioReponsavel() && (
//                     <Input
//                       id="emailResponsavel"
//                       name="emailResponsavel"
//                       label="E-mail Responsável"
//                       type="text"
//                     />
//                   )}
//                 </Form.Row>

//                 <Form.Row>
//                   <Checkbox
//                     id="utilizaMobile"
//                     name="utilizaMobile"
//                     label="Utiliza Mobile?"
//                   />
//                 </Form.Row>

//                 <Form.Column>
//                   <h3>Informações complementares</h3>
//                   {usuarioComplemento && usuarioComplemento.length ? (
//                     <Scope path="complemento">
//                       {splitArray(usuarioComplemento, 2).map((arr, idx1) => (
//                         <Form.Row key={idx1}>
//                           {arr.map((cp, idx2) =>
//                             nivelUsuario.value === opTipoAcesso.CLIENTE &&
//                             cp.descricao === 'WhatsApp' ? null : (
//                               <MaskedInput
//                                 key={idx2}
//                                 id={cp.chave}
//                                 name={cp.chave}
//                                 label={cp.descricao}
//                                 mask={cp.mascara}
//                               />
//                             )
//                           )}
//                         </Form.Row>
//                       ))}
//                     </Scope>
//                   ) : (
//                     <Form.NotFound>Nenhum item encontrado</Form.NotFound>
//                   )}
//                 </Form.Column>
//               </Form.Column>

//               <Form.Separate withFlex />

//               <Form.Footer>
//                 <button
//                   id="btn-cancel"
//                   type="button"
//                   onClick={() => history.goBack()}
//                 >
//                   Cancelar
//                 </button>
//                 <button id="btn-submit" type="submit" form="formUsuario">
//                   Salvar usuário
//                 </button>
//               </Form.Footer>
//             </Form>
//           </FormWrapper>
//         </LeftWrapper>

//         {/* LADO DIREITO - CATÁLOGOS */}
//         {showCatalogoPanel && (
//           <RightWrapper>
//             <FormWrapper>
//               <CatalogoCard>
//                 <CatalogoHeaderInfo>
//                   <div>
//                     <CatalogoTitleRow>
//                       <CatalogoTitle>
//                         Catálogos vinculados ao usuário
//                       </CatalogoTitle>
//                       <CatalogoCount>
//                         {catalogosSelecionados.length}
//                       </CatalogoCount>
//                     </CatalogoTitleRow>
//                     <CatalogoDescription>
//                       Selecione os catálogos da empresa que ficarão disponíveis
//                       para este usuário.
//                     </CatalogoDescription>
//                   </div>

//                   <CatalogoActionArea>
//                     <PrimaryButton
//                       type="button"
//                       onClick={handleSalvarCatalogos}
//                     >
//                       Salvar catálogos
//                     </PrimaryButton>
//                   </CatalogoActionArea>
//                 </CatalogoHeaderInfo>

//                 <CatalogoToolbar>
//                   <ToolbarButton
//                     type="button"
//                     onClick={handleSelecionarTodosCatalogos}
//                     title="Adicionar todos os catálogos"
//                   >
//                     <MdOutlineCheckBox size={20} color="#047857" />
//                   </ToolbarButton>

//                   <ToolbarButton
//                     type="button"
//                     onClick={handleDesmarcarTodosCatalogos}
//                     title="Remover todos os catálogos"
//                   >
//                     <MdOutlineIndeterminateCheckBox size={20} color="#b91c1c" />
//                   </ToolbarButton>

//                   <FilterContainer>
//                     <FilterLabel>
//                       Buscar por Classe Operacional ou Modelo
//                     </FilterLabel>
//                     <FilterInput
//                       type="text"
//                       value={filtroCatalogo}
//                       onChange={(e) => setFiltroCatalogo(e.target.value)}
//                       placeholder="Digite a classe operacional ou modelo"
//                       aria-label="Buscar por Classe Operacional ou Modelo"
//                     />
//                   </FilterContainer>
//                 </CatalogoToolbar>

//                 <Table>
//                   <TableHeader
//                     withPadding
//                     cbSort={() => {}}
//                     titles={[
//                       { fieldname: 'selecionado', title: 'Vincular' },
//                       { fieldname: 'nome', title: 'Classe Operacional' },
//                       { fieldname: 'modelo', title: 'Modelo' },
//                       { fieldname: 'fabricante', title: 'Fabricante' },
//                       { fieldname: 'versao', title: 'Versão' },
//                       // { fieldname: 'situacao', title: 'Situação' },
//                     ]}
//                   />
//                   <tbody>
//                     {empresaCatalogoFiltrado.length > 0 ? (
//                       empresaCatalogoFiltrado.map((catalogo) => (
//                         <RowMaster key={catalogo.idCatalogo}>
//                           <td>
//                             <input
//                               type="checkbox"
//                               checked={catalogosSelecionados.includes(
//                                 catalogo.idCatalogo
//                               )}
//                               onChange={() =>
//                                 handleToggleCatalogo(catalogo.idCatalogo)
//                               }
//                             />
//                           </td>
//                           <td>{catalogo.nome}</td>
//                           <td>{catalogo.modelo}</td>
//                           <td>{catalogo.fabricante}</td>
//                           <td>{catalogo.versao}</td>
//                           {/* <td>
//                             {opCatalogoSituacao[catalogo.situacao]
//                               ? opCatalogoSituacao[catalogo.situacao].label
//                               : ''}
//                           </td> */}
//                         </RowMaster>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan={6}>Nenhum catálogo encontrado</td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>

//                 {/* <Pagination
//                   ref={paginationRef}
//                   pageCount={totalPage}
//                   initialData={currentPage}
//                   onPageChange={(page) => {
//                     setCurrentPage(Number(page));
//                   }}
//                 /> */}
//               </CatalogoCard>
//             </FormWrapper>
//           </RightWrapper>
//         )}
//       </MasterWrapper>
//     </>
//   );
// }

// export { EmpresaUsuarioEditar };

import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import {
  MdOutlineCheckBox,
  MdOutlineIndeterminateCheckBox,
} from 'react-icons/md';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Scope } from '@unform/core';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { format, parseISO } from 'date-fns';

import api from '../../../../services/api';
import history from '../../../../services/history';

import { AppError } from '../../../../errors/AppError';
import {
  opTipoAcesso,
  opTipoDocumento,
  opMascaraDocumento,
} from '../../../../lib/const';
import {
  opAdministrador,
  opEmpresaAdministrador,
  opDocumento,
  opCatalogoSituacao,
} from '../../../../lib/inputOption';
import { YupValidaDocumento, splitArray } from '../../../../lib/inputUtils';

import {
  permiteEmpEmailUsuarioReponsavel,
  vinculaCatalogoUsuario,
} from '../../../../lib/paramUtils';

import TitleBar from '../../../../components/TitleBar';
import { FormWrapper, Form } from '../../../../components/Form';
import Input from '../../../../components/Form/Input';
import Select from '../../../../components/Form/Input/Select';
import Checkbox from '../../../../components/Form/Input/Checkbox';
import MaskedInput from '../../../../components/Form/Input/MaskedInput';
import { RowMaster, Table } from '../../../../components/Table';
import TableHeader from '../../../../components/Table/TableHeader';
import Pagination from '../../../../components/EditorAI/Pagination';
import {
  CatalogoActionArea,
  CatalogoCard,
  CatalogoCount,
  CatalogoDescription,
  CatalogoHeaderInfo,
  CatalogoTitle,
  CatalogoTitleRow,
  CatalogoToolbar,
  FilterContainer,
  FilterInput,
  FilterLabel,
  LeftWrapper,
  MasterWrapper,
  PrimaryButton,
  RightWrapper,
  ToolbarButton,
} from './styles';

const schema = Yup.object().shape({
  nome: Yup.string()
    .min(3, 'O campo "nome" precisa ter no mínimo 3 caracteres')
    .required('O campo "Nome" é obrigatório'),
  email: Yup.string()
    .email('E-mail inválido')
    .required('O campo "E-mail" é obrigatório'),
  emailResponsavel: Yup.string()
    .when('$paramField1', (paramField1, schema1) =>
      paramField1
        ? schema1.required('O campo "E-mail Responsável" é obrigatório')
        : schema1
    )
    .email('E-mail responsável é inválido'),
  adm: Yup.number()
    .typeError('O campo "Administrador" deve ser preenchido')
    .required('O campo "Administrador" é obrigatório'),
  utilizaMobile: Yup.string().oneOf(['0', '1']),
  tipoDocumento: Yup.number()
    .typeError('O campo "Documento" deve ser preenchido')
    .required('O campo "Documento" precisa ser preenchido'),
  documento: Yup.string()
    .required('O campo "Número Documento" é obrigatório')
    .test('documento', 'O documento é inválido', function isValid(value) {
      return YupValidaDocumento(value, this);
    }),
});

function EmpresaUsuarioEditar() {
  const formRef = useRef(null);
  const paginationRef = useRef(null);

  const catalogosInicializadosRef = useRef(new Set());

  const location = useLocation();
  const { idEmpresa, idUsuario } = location.state;

  const { adm: tipoAcesso } = useSelector((state) => state.user.profile || {});

  const [usuario, setUsuario] = useState({});
  const [usuarioComplemento, setUsuarioComplemento] = useState([]);
  const [tipoDocumento, setTipoDocumento] = useState(opTipoDocumento.CPF);
  const [nivelUsuario, setNivelUsuario] = useState(opAdministrador[0]);

  const [empresaCatalogo, setEmpresaCatalogo] = useState([]);
  const [catalogosSelecionados, setCatalogosSelecionados] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [filtroCatalogo, setFiltroCatalogo] = useState('');

  const showCatalogoPanel = vinculaCatalogoUsuario();

  const normalizaCatalogosSelecionados = useCallback((payload) => {
    const lista =
      payload?.catalogos ||
      payload?.catalogo ||
      payload?.usuarioCatalogo ||
      payload?.catalogosVinculados ||
      [];

    if (!Array.isArray(lista)) return [];

    return lista
      .map((item) =>
        typeof item === 'object' ? Number(item.idCatalogo) : Number(item)
      )
      .filter(Boolean);
  }, []);

  const carregaEmpresaCatalogo = useCallback(async () => {
    if (!showCatalogoPanel) return;

    try {
      const response = await api.get(`/empresa/${idEmpresa}/catalogo`, {
        params: {
          page: currentPage,
          idUsuario,
        },
      });

      const catalogos = response.data.catalogo
        .map(({ arquivo, empresas, ...catalogo }) => {
          const { modelos, fabricante } = arquivo;

          return {
            ...catalogo,
            fabricante: fabricante.descricao,
            modelo: modelos.map((m) => m.descricao).join(', '),
            relacionadoEmpresa:
              empresas.filter((e) => e.idEmpresa === idEmpresa).length > 0,
          };
        })
        .filter((catalogo) => catalogo.relacionadoEmpresa);

      setEmpresaCatalogo(catalogos);
      setTotalPage(response.data.total || 0);

      const idsVinculadosPagina = catalogos
        .filter((catalogo) => catalogo.vinculadoUsuario)
        .map((catalogo) => Number(catalogo.idCatalogo))
        .filter(Boolean);

      if (idsVinculadosPagina.length > 0) {
        setCatalogosSelecionados((oldState) => {
          const novosIds = idsVinculadosPagina.filter(
            (idCat) => !catalogosInicializadosRef.current.has(idCat)
          );

          if (novosIds.length === 0) {
            return oldState;
          }

          novosIds.forEach((idCat) =>
            catalogosInicializadosRef.current.add(idCat)
          );

          return [...new Set([...oldState, ...novosIds])];
        });
      }

      if (
        response.data.total > 0 &&
        currentPage > response.data.total &&
        paginationRef.current
      ) {
        paginationRef.current.setPage(1);
        setCurrentPage(1);
      }
    } catch (err) {
      AppError(err);
    }
  }, [idEmpresa, idUsuario, currentPage, showCatalogoPanel]);

  useEffect(() => {
    let mounted = true;

    async function carregaUsuario() {
      try {
        const response = await api.get(
          `empresa/${idEmpresa}/usuario/${idUsuario}`
        );

        if (!mounted) return;

        const {
          adm,
          utilizaMobile,
          tipoDocumento: tipoDoc,
          documento = '',
          dataDesa,
          complemento,
        } = response.data;

        const opAdm =
          Number(tipoAcesso) === opTipoAcesso.ADMIN_EMPRESA
            ? opEmpresaAdministrador.find(
                (item) => Number(item.value) === Number(adm)
              ) || opEmpresaAdministrador[0]
            : opAdministrador.find(
                (item) => Number(item.value) === Number(adm)
              ) || opAdministrador[0];

        formRef.current.setFieldValue('adm', opAdm);
        formRef.current.setFieldValue('utilizaMobile', utilizaMobile);
        formRef.current.setFieldValue(
          'tipoDocumento',
          opDocumento[tipoDoc] || opDocumento[0]
        );

        if (documento) {
          formRef.current.setFieldValue('documento', documento);
        }

        setTipoDocumento(tipoDoc || opTipoDocumento.CPF);
        setNivelUsuario(opAdm);

        /** o Form (unform) espera, dentro do Scope "complemento", um objeto
         * plano chaveado por `chave` (ex.: { cpTelefone: '11987654321' })
         * para conseguir preencher o defaultValue de cada MaskedInput — o
         * backend retorna um array de objetos ({idComplemento, chave,
         * descricao, mascara, valor}), por isso precisa ser convertido
         * antes de virar initialData do Form */
        const complementoIniciais = (complemento || []).reduce(
          (acumulado, cp) => {
            acumulado[cp.chave] = cp.valor || '';
            return acumulado;
          },
          {}
        );

        setUsuario({
          ...response.data,
          complemento: complementoIniciais,
          dataDesa: dataDesa
            ? format(parseISO(dataDesa), 'dd/MM/yyyy HH:mm:ss')
            : null,
        });

        setUsuarioComplemento(complemento);

        if (showCatalogoPanel) {
          const selecionadosDaResposta = normalizaCatalogosSelecionados(
            response.data
          );

          if (selecionadosDaResposta.length > 0) {
            setCatalogosSelecionados(selecionadosDaResposta);

            selecionadosDaResposta.forEach((idCat) =>
              catalogosInicializadosRef.current.add(Number(idCat))
            );
          } else {
            const responseCatalogoUsuario = await api.get(
              `/empresa/${idEmpresa}/usuario/${idUsuario}/catalogo`
            );

            if (!mounted) return;

            const idsNormalizados = normalizaCatalogosSelecionados(
              responseCatalogoUsuario.data
            );

            setCatalogosSelecionados(idsNormalizados);

            idsNormalizados.forEach((idCat) =>
              catalogosInicializadosRef.current.add(Number(idCat))
            );
          }
        }
      } catch (err) {
        AppError(err, formRef);
      }
    }

    carregaUsuario();

    return () => {
      mounted = false;
    };
  }, [
    idEmpresa,
    idUsuario,
    tipoAcesso,
    normalizaCatalogosSelecionados,
    showCatalogoPanel,
  ]);

  useEffect(() => {
    carregaEmpresaCatalogo();
  }, [carregaEmpresaCatalogo]);

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        await schema.validate(data, {
          context: {
            paramField1: permiteEmpEmailUsuarioReponsavel(),
          },
          abortEarly: false,
        });

        const {
          nome,
          email,
          emailResponsavel,
          adm,
          utilizaMobile,
          tipoDocumento: tipoDoc,
          documento,
          complemento,
        } = data;

        const fmtComplemento = complemento
          ? Object.entries(complemento).map(([chave, valor]) => ({
              chave,
              valor,
            }))
          : null;

        await api.put(`empresa/${idEmpresa}/usuario/${idUsuario}`, {
          nome,
          email,
          emailResponsavel,
          adm: String(adm),
          utilizaMobile: String(utilizaMobile),
          tipoDocumento: String(tipoDoc),
          documento,
          complemento: fmtComplemento,
        });

        toast.success('Usuário atualizado com sucesso!');
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [idEmpresa, idUsuario]
  );

  const handleSalvarCatalogos = useCallback(async () => {
    try {
      const payload = {
        catalogos: Array.isArray(catalogosSelecionados)
          ? catalogosSelecionados
          : [],
      };

      await api.post(
        `/empresa/${idEmpresa}/usuario/${idUsuario}/vinculo/catalogo`,
        payload
      );

      toast.success('Catálogos vinculados atualizados com sucesso!');
    } catch (err) {
      AppError(err);
    }
  }, [idEmpresa, idUsuario, catalogosSelecionados]);

  const handleTipoDocumento = useCallback((value) => {
    setTipoDocumento(value);
  }, []);

  const handleNivelUsuario = useCallback((usuarioSelecionado) => {
    setNivelUsuario(usuarioSelecionado);
  }, []);

  const handleToggleCatalogo = useCallback((idCatalogo) => {
    setCatalogosSelecionados((oldState) => {
      if (oldState.includes(idCatalogo)) {
        return oldState.filter((id) => id !== idCatalogo);
      }

      return [...oldState, idCatalogo];
    });
  }, []);

  const empresaCatalogoFiltrado = useMemo(() => {
    const termo = filtroCatalogo.trim().toLowerCase();

    if (!termo) return empresaCatalogo;

    return empresaCatalogo.filter((catalogo) => {
      const nome = String(catalogo.nome || '').toLowerCase();
      const modelo = String(catalogo.modelo || '').toLowerCase();

      return nome.includes(termo) || modelo.includes(termo);
    });
  }, [empresaCatalogo, filtroCatalogo]);

  const handleSelecionarTodosCatalogos = useCallback(() => {
    const idsDaPagina = empresaCatalogo
      .map((catalogo) => Number(catalogo.idCatalogo))
      .filter(Boolean);

    setCatalogosSelecionados((oldState) => [
      ...new Set([...oldState, ...idsDaPagina]),
    ]);
  }, [empresaCatalogo]);

  const handleDesmarcarTodosCatalogos = useCallback(() => {
    const idsDaPagina = empresaCatalogo
      .map((catalogo) => Number(catalogo.idCatalogo))
      .filter(Boolean);

    setCatalogosSelecionados((oldState) =>
      oldState.filter((id) => !idsDaPagina.includes(Number(id)))
    );
  }, [empresaCatalogo]);

  return (
    <>
      <TitleBar back={!!location.background} title="Alterar Usuário" />

      <MasterWrapper $showCatalogoPanel>
        {/* LADO ESQUERDO - DADOS DO USUÁRIO */}
        <LeftWrapper>
          <FormWrapper>
            <Form
              id="formUsuario"
              ref={formRef}
              initialData={usuario}
              onSubmit={handleConfirmar}
              autoComplete="off"
            >
              <Form.Column>
                <Form.Row>
                  <Input
                    id="login"
                    name="login"
                    label="Login"
                    type="text"
                    disabled
                  />
                  <Input
                    id="dataDesa"
                    name="dataDesa"
                    label="Data desativação"
                    type="text"
                    width={500}
                    disabled
                  />
                </Form.Row>

                <Form.Row>
                  <Input id="nome" name="nome" label="Nome" type="text" />
                  <Input id="email" name="email" label="E-mail" type="text" />
                </Form.Row>

                <Form.Row>
                  {tipoAcesso === opTipoAcesso.ADMIN_PLATAFORMA && (
                    <Select
                      id="adm"
                      name="adm"
                      label="Administrador"
                      isSearchable={false}
                      defaultValue={opAdministrador[0]}
                      options={opAdministrador}
                      onChange={(usuarioSelecionado) =>
                        handleNivelUsuario(usuarioSelecionado)
                      }
                    />
                  )}

                  {tipoAcesso === opTipoAcesso.ADMIN_EMPRESA && (
                    <Select
                      id="adm"
                      name="adm"
                      label="Administrador"
                      isSearchable={false}
                      defaultValue={opEmpresaAdministrador[0]}
                      options={opEmpresaAdministrador}
                      onChange={(usuarioSelecionado) =>
                        handleNivelUsuario(usuarioSelecionado)
                      }
                    />
                  )}

                  <Select
                    id="tipoDocumento"
                    name="tipoDocumento"
                    label="Documento"
                    defaultValue={opDocumento[opTipoDocumento.CPF]}
                    options={opDocumento}
                    isSearchable={false}
                    onChange={({ value }) => {
                      handleTipoDocumento(value);
                    }}
                    width={400}
                  />

                  <MaskedInput
                    id="documento"
                    name="documento"
                    label="Número Documento"
                    mask={opMascaraDocumento[tipoDocumento] || ''}
                  />
                </Form.Row>

                <Form.Row>
                  {permiteEmpEmailUsuarioReponsavel() && (
                    <Input
                      id="emailResponsavel"
                      name="emailResponsavel"
                      label="E-mail Responsável"
                      type="text"
                    />
                  )}
                </Form.Row>

                <Form.Row>
                  <Checkbox
                    id="utilizaMobile"
                    name="utilizaMobile"
                    label="Utiliza Mobile?"
                  />
                </Form.Row>

                <Form.Column>
                  <h3>Informações complementares</h3>
                  {usuarioComplemento && usuarioComplemento.length ? (
                    <Scope path="complemento">
                      {splitArray(usuarioComplemento, 2).map((arr, idx1) => (
                        <Form.Row key={idx1}>
                          {arr.map((cp, idx2) =>
                            nivelUsuario.value === opTipoAcesso.CLIENTE &&
                            cp.descricao === 'WhatsApp' ? null : (
                              <MaskedInput
                                key={idx2}
                                id={cp.chave}
                                name={cp.chave}
                                label={cp.descricao}
                                mask={cp.mascara}
                              />
                            )
                          )}
                        </Form.Row>
                      ))}
                    </Scope>
                  ) : (
                    <Form.NotFound>Nenhum item encontrado</Form.NotFound>
                  )}
                </Form.Column>
              </Form.Column>

              <Form.Separate withFlex />

              <Form.Footer>
                <button
                  id="btn-cancel"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Cancelar
                </button>
                <button id="btn-submit" type="submit" form="formUsuario">
                  Salvar usuário
                </button>
              </Form.Footer>
            </Form>
          </FormWrapper>
        </LeftWrapper>

        {/* LADO DIREITO - CATÁLOGOS */}
        {showCatalogoPanel && (
          <RightWrapper>
            <FormWrapper>
              <CatalogoCard>
                <CatalogoHeaderInfo>
                  <div>
                    <CatalogoTitleRow>
                      <CatalogoTitle>
                        Catálogos vinculados ao usuário
                      </CatalogoTitle>
                      <CatalogoCount>
                        {catalogosSelecionados.length}
                      </CatalogoCount>
                    </CatalogoTitleRow>
                    <CatalogoDescription>
                      Selecione os catálogos da empresa que ficarão disponíveis
                      para este usuário.
                    </CatalogoDescription>
                  </div>

                  <CatalogoActionArea>
                    <PrimaryButton
                      type="button"
                      onClick={handleSalvarCatalogos}
                    >
                      Salvar catálogos
                    </PrimaryButton>
                  </CatalogoActionArea>
                </CatalogoHeaderInfo>

                <CatalogoToolbar>
                  <ToolbarButton
                    type="button"
                    onClick={handleSelecionarTodosCatalogos}
                    title="Adicionar todos os catálogos"
                  >
                    <MdOutlineCheckBox size={20} color="#047857" />
                  </ToolbarButton>

                  <ToolbarButton
                    type="button"
                    onClick={handleDesmarcarTodosCatalogos}
                    title="Remover todos os catálogos"
                  >
                    <MdOutlineIndeterminateCheckBox size={20} color="#b91c1c" />
                  </ToolbarButton>

                  <FilterContainer>
                    <FilterLabel>
                      Buscar por Classe Operacional ou Modelo
                    </FilterLabel>
                    <FilterInput
                      type="text"
                      value={filtroCatalogo}
                      onChange={(e) => setFiltroCatalogo(e.target.value)}
                      placeholder="Digite a classe operacional ou modelo"
                      aria-label="Buscar por Classe Operacional ou Modelo"
                    />
                  </FilterContainer>
                </CatalogoToolbar>

                <Table>
                  <TableHeader
                    withPadding
                    cbSort={() => {}}
                    titles={[
                      { fieldname: 'selecionado', title: 'Vincular' },
                      { fieldname: 'nome', title: 'Classe Operacional' },
                      { fieldname: 'modelo', title: 'Modelo' },
                      { fieldname: 'fabricante', title: 'Fabricante' },
                      { fieldname: 'versao', title: 'Versão' },
                      // { fieldname: 'situacao', title: 'Situação' },
                    ]}
                  />
                  <tbody>
                    {empresaCatalogoFiltrado.length > 0 ? (
                      empresaCatalogoFiltrado.map((catalogo) => (
                        <RowMaster key={catalogo.idCatalogo}>
                          <td>
                            <input
                              type="checkbox"
                              checked={catalogosSelecionados.includes(
                                catalogo.idCatalogo
                              )}
                              onChange={() =>
                                handleToggleCatalogo(catalogo.idCatalogo)
                              }
                            />
                          </td>
                          <td>{catalogo.nome}</td>
                          <td>{catalogo.modelo}</td>
                          <td>{catalogo.fabricante}</td>
                          <td>{catalogo.versao}</td>
                          {/* <td>
                            {opCatalogoSituacao[catalogo.situacao]
                              ? opCatalogoSituacao[catalogo.situacao].label
                              : ''}
                          </td> */}
                        </RowMaster>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>Nenhum catálogo encontrado</td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                {/* <Pagination
                  ref={paginationRef}
                  pageCount={totalPage}
                  initialData={currentPage}
                  onPageChange={(page) => {
                    setCurrentPage(Number(page));
                  }}
                /> */}
              </CatalogoCard>
            </FormWrapper>
          </RightWrapper>
        )}
      </MasterWrapper>
    </>
  );
}

export { EmpresaUsuarioEditar };
